import {MakeStore, StoreObject} from "../../../stem-core/src/state/Store";
import {field} from "../misc/StoreField";
import {apiClient} from "../../connection/BlinkApiConnection";

class MerchantSettingsVersion extends StoreObject {
    @field("Merchant") merchant;

    @field(Boolean) isMaster;
    @field(String) key;
    @field(String) name;
    @field(String) description;
    @field(Date) createdAt;
    @field("MerchantSettingsVersion") parentVersion;
}

export const MerchantSettingsVersionStore = MakeStore("MerchantSettingsVersion", MerchantSettingsVersion, {
    dependencies: ["Merchant"],
});

export async function apiMerchantApplySettingsVersion(data) {
    return apiClient.post("/merchant/apply_settings_version/", data);
}

export async function apiMerchantDeleteSettingsVersion(data) {
    return apiClient.post("/merchant/delete_settings_version/", data);
}
